export default __webpack_public_path__ + "static/media/hippo_standup.3adb116b.png";